// Product search used across the app (Oct 2026).
// Typing a complete SKU or ASIN shows only that product — e.g. "20-20-006" no longer also lists 20-20-006-6.7 or
// 2PK-20-20-006. Anything else (part of a SKU, a word from the description) still matches broadly.
//
//   items     the list being filtered (exact mode turns on when one of them has that exact SKU / ASIN)
//   query     what was typed
//   fallback  (item, lowercasedQuery) => boolean — the page's normal partial-text match
//   get       item => the product-like object holding sku / asin (defaults to the item itself)
const low = v => String(v ?? '').trim().toLowerCase()

export function searchFilter(items, query, fallback, get = x => x) {
  const q = low(query)
  if (!q) return () => true
  const isCode = it => { const p = get(it) || {}; return low(p.sku) === q || low(p.asin) === q }
  if ((items || []).some(isCode)) return isCode
  return it => fallback(it, q)
}
